// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__29C4A","checkboxCol":"Table_checkboxCol__1xKEV","emailCol":"Table_emailCol__1QVa3","actionCol":"Table_actionCol__NAJvb"};